const collections = [
  {
    title: '暑期档必看',
    desc: '炎炎夏日，宅家看大片。精选暑期热门新片与经典好片，承包你的整个夏天。',
    count: '86部',
    img: 'https://readdy.ai/api/search-image?query=Summer%20movie%20night%20aesthetic%20with%20popcorn%20and%20film%20reel%2C%20warm%20golden%20hour%20lighting%2C%20cozy%20living%20room%20with%20projector%2C%20cinematic%20mood%2C%20soft%20bokeh%20background%2C%20vintage%20movie%20posters%20on%20wall%2C%20relaxing%20atmosphere%2C%20high%20detail%20editorial%20photography&width=800&height=500&seq=collection-summer-97&orientation=landscape',
    emoji: '🎬'
  },
  {
    title: '豆瓣高分精选',
    desc: '评分8.5以上口碑佳作，经过千万影迷检验的必看经典电影合集。',
    count: '120部',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20bookshelf%20with%20classic%20films%20collection%2C%20warm%20ambient%20lighting%2C%20vintage%20camera%20and%20film%20strips%2C%20intellectual%20cinema%20atmosphere%2C%20wooden%20textures%2C%20soft%20shadows%2C%20editorial%20style%2C%20rich%20warm%20tones&width=800&height=500&seq=collection-douban-97&orientation=landscape',
    emoji: '⭐'
  },
  {
    title: '奥斯卡获奖影片',
    desc: '历届奥斯卡最佳影片、最佳导演、最佳男女主角获奖作品全收录。',
    count: '95部',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20golden%20statue%20on%20red%20carpet%2C%20luxurious%20theater%20interior%20with%20velvet%20curtains%2C%20dramatic%20stage%20lighting%2C%20prestigious%20award%20ceremony%20atmosphere%2C%20warm%20golden%20and%20deep%20red%20color%20palette%2C%20cinematic%20composition&width=800&height=500&seq=collection-oscar-97&orientation=landscape',
    emoji: '🏆'
  },
  {
    title: '漫威宇宙合集',
    desc: '从《钢铁侠》到《复仇者联盟》，完整的漫威电影宇宙观影顺序。',
    count: '42部',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20superhero%20comic%20book%20collage%20style%2C%20bold%20action%20colors%20with%20deep%20red%20and%20gold%20accents%2C%20dynamic%20composition%2C%20cinematic%20lighting%2C%20modern%20pop%20art%20aesthetic%2C%20high%20contrast%2C%20vibrant%20detailed%20illustration&width=800&height=500&seq=collection-marvel-97&orientation=landscape',
    emoji: '🦸'
  },
  {
    title: 'DC英雄系列',
    desc: '蝙蝠侠、超人、神奇女侠等经典DC超级英雄电影大合集热血来袭。',
    count: '36部',
    img: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20city%20skyline%20at%20night%20with%20storm%20clouds%2C%20gothic%20architecture%2C%20moody%20cinematic%20lighting%2C%20deep%20shadows%2C%20rain%20on%20street%2C%20noir%20aesthetic%2C%20high%20contrast%2C%20atmospheric%20photography&width=800&height=500&seq=collection-dc-97&orientation=landscape',
    emoji: '🦇'
  },
  {
    title: '日韩热播剧场',
    desc: '精选日本动画电影与韩国高分剧情片，日韩影视佳作持续更新中。',
    count: '68部',
    img: 'https://readdy.ai/api/search-image?query=Modern%20Asian%20cinema%20minimalist%20poster%20design%20style%2C%20soft%20pastel%20colors%20with%20warm%20accent%20tones%2C%20clean%20geometric%20composition%2C%20delicate%20cherry%20blossom%20elements%2C%20contemporary%20film%20aesthetic%2C%20sophisticated%20visual%20design&width=800&height=500&seq=collection-jk-97&orientation=landscape',
    emoji: '🌸'
  },
  {
    title: '经典港片回忆',
    desc: '周星驰喜剧、成龙动作、王家卫文艺，重温香港电影黄金年代。',
    count: '150部',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20Hong%20Kong%20street%20at%20night%20with%20neon%20signs%2C%20retro%20cinema%20aesthetic%2C%20warm%20nostalgic%20lighting%2C%20old%20school%20movie%20posters%2C%20rainy%20alley%2C%20classic%20film%20vibe%2C%20atmospheric%20urban%20photography&width=800&height=500&seq=collection-hk-97&orientation=landscape',
    emoji: '🎭'
  },
];

export default function Index() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2 text-center">
          精选专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          七大专题合集，总有一款适合你的观影口味
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {collections.map((c) => (
            <a
              key={c.title}
              href={`#${c.title}`}
              className="group block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={c.img}
                  alt={c.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 text-2xl">{c.emoji}</span>
                <span className="absolute bottom-3 right-3 text-xs text-white/80 bg-black/30 backdrop-blur-sm px-2 py-0.5 rounded-full">
                  {c.count}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                  {c.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {c.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}